<template>
  <div class="container">
    <div class="cmr-button" @click="$router.push(path)">
      <!-- 跳转按钮设计 -->
      <div class="left-arrow">
        <svg-icon iconClass="button-right-arrow"></svg-icon>
      </div>
      <!-- <div class="right-content">{{ text }}</div> -->
      <!-- <div class="cover"></div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "Learn more",
    },
    path: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  // width: 3rem;
  //   margin-left: 1.8rem;
  .cmr-button {
    display: inline-block;

    overflow: hidden;
    position: relative;
    // width: fit-content;
    .left-arrow {
      // display: inline-block;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99;
      font-size: 0.3rem;
      width: 0.6rem;
      height: 0.6rem;
      border-radius: 50%;
      border: 0.055rem solid #f8d9e2;
      background-color: #fff;
      transition: all 0.3s ease-in-out;
      &:hover {
        border: 0.055rem solid #b94060;
      }
    }
    .right-content {
      // display: inline-block;
      box-sizing: border-box;
      padding-left: 0.4rem;
      padding-right: 0.35rem;
      line-height: 0.6rem;
      position: absolute;
      left: -100%;
      // opacity: 0;
      // transform: translateX(-1.5rem);
      border-top: 0.055rem solid #b94060;
      border-right: 0.055rem solid #b94060;
      border-bottom: 0.055rem solid #b94060;
      transition: all 0.3s ease-in-out;
    }
    .cover {
      position: absolute;
      width: 0.35rem;
      z-index: 60;
      height: 100%;
      background-color: #fff;
    }
    &:hover {
      cursor: pointer;
      .right-content {
        left: 0.4rem;
      }
      .left-arrow {
        border: 0.055rem solid #b94060;
      }
    }
  }
}
@media screen and (max-width: 760px) {
  .container {
    // width: 4rem;
    .cmr-button {
      .left-arrow {
        border: 0.055rem solid #b94060;
        font-size: 0.35rem;
        width: 0.7rem;
        height: 0.7rem;
      }
      .right-content {
        line-height: 0.7rem;
        padding-left: 0.55rem;
        left: 0.4rem;
      }
    }
  }
}
</style>
